// Mirrors backend `mascots/constants.py::MASCOT_EXPRESSIONS` and the
// frontend_v3 `MascotExpression` union. `idle` is the canonical fallback.
export const EXPRESSIONS = ['idle', 'neutral', 'angry', 'excited', 'sad', 'shocked']

export const RARITIES = ['common', 'rare', 'epic', 'legendary']
